<template>
    <footer class="footer-container">
        <span>&copy; {{new Date().getFullYear()}} - ExtractAlpha Research Limited - All Rights Reserved </span>
    </footer>
</template>
